import {
  GET_CV,
  GET_CV_BY_ID,
  GET_CV_MINE,
  GET_CATEGORY_CANDIDATE_CV,
  GET_CV_DETAILS_BY_ID,
  GET_FILTERD_CV,
  GET_ALREADY_DOWNLOADED_CV_LIST,
} from "../constants/index";

export const cv = (
  state = {
    getcvlist: [],
    getcvbyid: {},
    getminecvlist: [],
    getcvcandidatelistcategory: [],
    getcvbyuserid: {},
    getfilterdcv: {},
    getalreadydownloadedcvlist: {},
  },
  action
) => {
  switch (action.type) {
    case GET_CV:
      return { ...state, getcvlist: action.getcvlist };
    case GET_CV_MINE:
      return { ...state, getminecvlist: action.getminecvlist };
    case GET_CV_BY_ID:
      return { ...state, getcvbyid: action.getcvbyid };
    case GET_FILTERD_CV:
      return { ...state, getfilterdcv: action.getfilterdcv };
    case GET_ALREADY_DOWNLOADED_CV_LIST:
      return {
        ...state,
        getalreadydownloadedcvlist: action.getalreadydownloadedcvlist,
      };
    case GET_CATEGORY_CANDIDATE_CV:
      return {
        ...state,
        getcvcandidatelistcategory: action.getcvcandidatelistcategory,
      };
    case GET_CV_DETAILS_BY_ID:
      return { ...state, getcvbyuserid: action.getcvbyuserid };
    default:
      return state;
  }
};
